/**
 * Backend configuration.
 *
 * The application talks to this provider boundary instead of importing a
 * vendor SDK from feature code. To replace the backend, implement another
 * provider under src/backend/providers and change VITE_BACKEND_PROVIDER.
 */
export const BACKEND_PROVIDER = String(import.meta.env.VITE_BACKEND_PROVIDER || 'supabase').trim().toLowerCase();
